import createCache, { EmotionCache } from '@emotion/cache';

export const createEmotionCache = (): EmotionCache => createCache({ key: 'css', prepend: true });

export const createTssCache = (): EmotionCache => createCache({ key: 'tss-mui' });

export default createEmotionCache;
